/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SharedRespLinksBlock_links = ReadonlyArray<{
    readonly url: string | null;
    readonly anchorText: string | null;
    readonly " $refType": "SharedRespLinksBlock_links";
}>;
export type SharedRespLinksBlock_links$data = SharedRespLinksBlock_links;
export type SharedRespLinksBlock_links$key = ReadonlyArray<{
    readonly " $data"?: SharedRespLinksBlock_links$data;
    readonly " $fragmentRefs": FragmentRefs<"SharedRespLinksBlock_links">;
}>;



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SharedRespLinksBlock_links",
  "type": "InternalBuyLinkType",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "url",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "anchorText",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = '1a3b3ca9ce0eddc9a235d71394dd478d';
export default node;
